export const SOLD_SUBSCRIPTION_PAYNL_PAYMENT_TYPE = {
    FLEXIBLE_DIRECT_DEBIT: 'flexible direct debit',
    MANDATE_CREATION: 'mandate creation',
    IDEAL: 'ideal',
};
